import 'mapbox-gl/dist/mapbox-gl.css';
import 'styles/reset.scss';
import 'styles/globals.scss';

import { UIContextProvider } from 'contexts/UIContext';
import { useEffect } from 'react';
import { SettingsContextProvider } from 'contexts/SettingContext';
import { useRouter } from 'next/router';
import Head from 'next/head';
import {
  initGTM,
  initKlaviyo,
  loadCookieScript,
  setupConvertConsent,
  setupCookieConsentListener,
} from 'lib/utils/helpers';
import { GlobalModulesProvider } from 'contexts';
import { useDidMountEffect } from '../hooks';

function MyApp({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    setupConvertConsent();
    const isProd = window.location.hostname === process.env.NEXT_PUBLIC_SITE_HOSTNAME;
    if (!window.gtmDidInit && isProd) {
      if (router.locale === 'de') {
        loadCookieScript();
        setupCookieConsentListener(router.locale);
      } else {
        initGTM(undefined, router.locale);
      }
    } else if (!isProd) {
      initKlaviyo(router.locale);
    }
  }, []);

  // Used for page-view tracking
  useDidMountEffect(() => {
    if (typeof window !== 'undefined' && window.dataLayer && !router.asPath.includes('salon/')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ page: null }); // Clear the previous page object.
      window.dataLayer.push({
        event: 'route-change',
        page: {
          page_title: document.title,
          page_location: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`,
          page_path: router.asPath,
        },
      });
    }
  }, [router.asPath]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.dataLayer && !router.asPath.includes('salon/')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ page: null }); // Clear the previous page object.
      window.dataLayer.push({
        event: 'route-change',
        page: {
          page_title: document.title,
          page_location: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`,
          page_path: router.asPath,
        },
      });
    }
  }, []);

  // useEffect(() => {
  //   if (router.isReady) {
  //     window._sqzl = window._sqzl || [];
  //     window._sqzl.push({ event: 'PageView' });
  //     window._sqzl.push({ event: 'ReloadPersonalization' });
  //   }
  // }, [router]);

  return (
    <UIContextProvider>
      <SettingsContextProvider>
        <GlobalModulesProvider globalModules={pageProps?.globalModules}>
          <Head>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          </Head>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Component {...pageProps} />
        </GlobalModulesProvider>
      </SettingsContextProvider>
    </UIContextProvider>
  );
}

export default MyApp;
